<template>
  <b-table
    :items="_products"
    :fields="fields"
  >
    <template #cell(select)="row">
      <b-form-checkbox
        v-model="$store.state.productV2.selectedProducts"
        :value="row.item"
        :disabled="!!row.item.isBundle"
        class="custom-control-secondary"
      />
      {{ row.item.id }}
    </template>

    <template #cell(image)="row">
      <b-img
        :src="row.item.images && row.item.images[0] && row.item.images[0].url ? 'https://api.kitapfirsatlari.com/' + row.item.images[0].url : ''"
        thumbnail
        fluid
        alt="Ürün Görseli"
        style="max-width: 150px;"
      />
    </template>

    <template #cell(product_detail)="row">
      <div>
        <span
          v-if="row.item.isBundle"
          class="text-primary font-weight-bold"
        >Takım</span>
        <span
          v-else
          class="text-success"
        >Ürün</span> <br>
        {{ row.item.name }} <br>
        {{ row.item.barcode }} <br>
        {{ row.item.brand ? row.item.brand.name : '' }}
      </div>
      <div>
        <a
          v-for="supplier_product in row.item.supplier_products"
          :key="supplier_product.id"
          :href="supplier_product.url || '#'"
          class="btn btn-sm"
          :class="[9,27].includes(supplier_product.supplier_id)?'btn-outline-warning':'btn-outline-primary'"
          size="sm"
          @click.prevent="handleClick(supplier_product.url)"
        >
          {{ supplier_product.supplier.name }} - {{ supplier_product.price }} {{ supplier_product.currency }} -
          {{ supplier_product.stock }} Ad.
        </a>
      </div>
      <div>
        <ProdcutDetail :product="row.item" />
      </div>
    </template>

    <template #cell(actions)="row">
      <b-btn-group size="sm">
        <b-button
          v-b-popover.hover.top="'Stokları yeniden hesapla'"
          variant="primary"
          size="sm"
          @click="recalculateInventory([row.item.id])"
        >
          <feather-icon icon="PackageIcon" />
        </b-button>
        <b-button
          v-b-popover.hover.top="'Ürün bilgileri düzenle'"
          variant="primary"
          size="sm"
          @click="editProduct($event, row.item)"
        >
          <feather-icon icon="EditIcon" />
        </b-button>
        <b-button
          v-b-popover.hover.top="'Satış İstatistikleri'"
          @click="getOrderProductStatistics($event,row.item.id)"
        >
          <feather-icon icon="BarChart2Icon" />
        </b-button>
        <b-button
          v-b-popover.hover.top="'Yeni Barkod Ekle'"
          variant="warning"
          @click="addProductBarcode(row.item.id)"
        >
          <b-icon-bookmark-plus />
        </b-button>

        <b-button
          v-b-popover.hover.top="'Barkod Listesi Düzenle'"
          variant="success"
          @click="getProductBarcodeList($event,row.item)"
        >
          <b-icon-bookmarks />
        </b-button>

        <b-button
          v-if="user.roles.includes('manager')"
          v-b-popover.hover.top="'KDV Düzelt'"
          variant="warning"
          @click="vatSelector(row.item)"
        >
          <feather-icon icon="DollarSignIcon" />
        </b-button>

        <b-button
          v-b-popover.hover.top="'Ürün detaylarını düzenle'"
          size="sm"
          variant="info"
          class="mr-2"
          @click="toggleDetails(row)"
        >
          <feather-icon
            v-if="row.detailsShowing"
            icon="EyeOffIcon"
          />
          <feather-icon
            v-else
            icon="EyeIcon"
          />
        </b-button>
      </b-btn-group>
      <div class="mt-2">
        <a 
          :href="`/trendyol/urun-ara?product_id=${row.item.id}&barcode=${row.item.barcode}&name=${row.item.name}`" 
          target="_blank"
          class="btn btn-sm btn-info"
        >
          <feather-icon icon="SearchIcon" v-b-popover.hover.top="'Trendyolda Ara'"/>
        </a>
      </div>
    </template>

    <!-- Satır detayları slot'u -->
    <template #row-details="row">
      <ProdcutDetail :product="row.item" />
    </template>
  </b-table>
</template>

<script>
import { mapGetters } from 'vuex'
import ProdcutDetail from '@/views/v2/products/ProductDetail.vue'
import recalculateInventoryMixins from '@/mixins/recalculateInventoryMixins'

export default {
  name: 'ProductsTable',
  components: { ProdcutDetail },
  mixins: [recalculateInventoryMixins],
  data: () => ({
    user: JSON.parse(localStorage.getItem('userData')),
    fields: [
      { key: 'select', label: 'Seç' },
      { key: 'image', label: 'Görsel' },
      { key: 'product_detail', label: 'Ürün Bilgileri' },
      { key: 'actions', label: 'Düzenle', class: 'text-center' },
    ],
  }),
  computed: {
    ...mapGetters('productV2', ['_products']),
  },
  methods: {
    toggleDetails(row) {
      row.toggleDetails()
    },
    editProduct(event, item) {
      this.$store.commit('product/setEditProduct', item)
      this.$root.$emit('bv::show::modal', 'edit-product-modal', event.target)
    },
    handleClick(url) {
      if (url) {
        window.open(url, 'newTab')
      }
    },
    getProductBarcodeList(event, product) {
      this.$store.commit('product/setEditProduct', product)
      this.$root.$emit('bv::show::modal', 'edit-product-barcodes-modal', event.target)
    },
    getOrderProductStatistics(event, produdctId) {
      this.$store.state.order.orderProductStatisticsProductId = produdctId
      this.$root.$emit('bv::show::modal', 'order-product-statistics-modal', event.target)
    },
    async vatSelector(product) {
      /* inputOptions can be an object or Promise */
      const { value: vatRate } = await this.$swal.fire({
        title: 'KDV Oranı Seçiniz',
        input: 'radio',
        inputOptions: {
          0: '%0', 1: '%1', 8: '%8', 18: '%18',
        },
        inputValidator: value => {
          if (!value) {
            return 'Bir KDV oranı seçmelisiniz!'
          }
        },
      })

      if (vatRate) {
        await this.$store.dispatch('product/updateProduct', { id: product.id, tax_rate: vatRate })
          .then(res => {
            // this.$swal({html: `${res.message} (${vatRate})`})
          })
      }
    },
    addProductBarcode(productId) {
      const newBarcode = prompt('Lütfen Yeni Barkodu Giriniz', '')
      if (newBarcode != null) {
        this.$store.dispatch('product/storeProductBarcode', { product_id: productId, barcode: newBarcode })
          .then(res => {
            this.$swal({
              title: res.message,
              icon: res.icon,
            })
          })
      }
    },
  },
}

</script>
